import type { IconType } from 'react-icons'
import { DUO_CAFE_LOGO, getAppIconOverride } from '../../config/appIcons'
import { REACT_ICONS } from '../../config/reactIcons'
import { toSafeExternalUrl } from '../../common/safeExternalUrl'

// Reuse the header's mappings and the original assets from the other Duo apps.
const BRAND_HOSTS: Record<string, string> = {
  'valai.duo.tax': '/valai.svg',
  'books.duo.tax': '/duo-books-app.svg',
  'qs.duo.tax': '/duo_qs_logo.svg',
  'salesforce.com': '/salesforce-icon.svg',
}
const BRAND_NAMES: Record<string, string> = {
  'duo valai': '/valai.svg', valai: '/valai.svg',
  'duo books': '/duo-books-app.svg', salesforce: '/salesforce-icon.svg',
  'duo qs calendar': '/duo_qs_logo.svg',
}
const PAGE_IMAGES: Record<string, string> = {
  '/handbook': '/duobooks.svg',
  '/it-tickets': '/ticket.png',
  '/cafe': DUO_CAFE_LOGO,
  '/cafe/history': DUO_CAFE_LOGO,
  '/security-training': '/cyberhoot_logo.png',
  '/einstein-submission': '/einstein_logo.png',
  '/superstar': '/superstar_trophy.png',
  '/interviews': '/interviews_icon.svg',
}

export function getResourceIcon(name: string, path: string, configuredIcon?: string): { imageSrc?: string; icon?: IconType } {
  const normalName = name.toLowerCase().replace(/[_-]+/g, ' ').trim()
  let branded: string | undefined = BRAND_NAMES[normalName]
  try {
    const url = new URL(path, window.location.origin)
    branded ||= Object.entries(BRAND_HOSTS).find(([host]) => url.hostname === host || url.hostname.endsWith(`.${host}`))?.[1]
    if (url.origin === window.location.origin) branded ||= PAGE_IMAGES[url.pathname]
  } catch { /* Invalid resource destinations are filtered by the catalogue. */ }

  const icon = configuredIcon ? REACT_ICONS[configuredIcon] as IconType | undefined : undefined
  const imageSrc = getAppIconOverride(name, path) || branded || (!icon && configuredIcon) || undefined
  if (imageSrc && toSafeExternalUrl(imageSrc)) return { imageSrc, ...(icon ? { icon } : {}) }
  return icon ? { icon } : {}
}
